export { default as Animation } from './animations/animation';
export { default as AnimationFactory } from './animations/animation-factory';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/animations.js
// module id = 1373
// module chunks = 0